import { TCartItem } from '@/lib/cart/useCart';
import { IS_PREVIEW } from '@/utils/env';
import {
  pushToElevarDataLayer,
  getUserProperties,
  transformCartItemToElevar,
  getReferrerList,
} from './utils';
import { ElevarRemoveFromCartEvent } from './types';

/**
 * Elevar remove from cart tracking.
 * Call this function when a product is removed from cart.
 */
export const handleElevarRemoveFromCart = (cartItem: TCartItem) => {
  if (IS_PREVIEW) return;

  const userProperties = getUserProperties();
  const referrerList = getReferrerList();

  const elevarProduct = transformCartItemToElevar(cartItem, 1, referrerList);

  const event: ElevarRemoveFromCartEvent = {
    event: 'dl_remove_from_cart',
    user_properties: userProperties,
    ecommerce: {
      currencyCode: 'USD',
      remove: {
        actionField: {
          list: referrerList,
        },
        products: [elevarProduct],
      },
    },
  };

  pushToElevarDataLayer(event);
};
